export default {
  ProductAccessoriesIcon: () =>
    import(
      /* webpackChunkName: "ProductAccessoriesIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Product/ProductAccessoriesIcon.vue'
    ),
  ProductDiscBrakeRotorFrontIcon: () =>
    import(
      /* webpackChunkName: "ProductDiscBrakeRotorFrontIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Product/ProductDiscBrakeRotorFrontIcon.vue'
    ),
  ItemRotorDescriptionIcon: () =>
    import(
      /* webpackChunkName: "ProductDiscBrakeRotorFrontIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Product/ProductDiscBrakeRotorFrontIcon.vue'
    ),
  ProductDriveTrainIcon: () =>
    import(
      /* webpackChunkName: "ProductDriveTrainIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Product/ProductDriveTrainIcon.vue'
    ),
  ProductBarendIcon: () =>
    import(
      /* webpackChunkName: "ProductBarendIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Product/ProductBarendIcon.vue'
    ),
  ProductWheelsetIcon: () =>
    import(
      /* webpackChunkName: "ProductWheelsetIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Product/ProductWheelsetIcon.vue'
    ),
  ProductKickstandDescriptionIcon: () =>
    import(
      /* webpackChunkName: "ProductKickstandDescriptionIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Product/ProductKickstandDescriptionIcon.vue'
    ),
  ProductMaxTotalWeightKgIcon: () =>
    import(
      /* webpackChunkName: "ProductMaxTotalWeightKgIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Product/ProductMaxTotalWeightKgIcon.vue'
    ),
  ProductBrakeSystemIcon: () =>
    import(
      /* webpackChunkName: "ProductBrakeSystemIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Product/ProductBrakeSystemIcon.vue'
    ),
  ProductCranksetIcon: () =>
    import(
      /* webpackChunkName: "ProductCranksetIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Product/ProductCranksetIcon.vue'
    ),
  ProductWheelRimDescriptionIcon: () =>
    import(
      /* webpackChunkName: "ProductWheelRimDescriptionIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Product/ProductWheelRimDescriptionIcon.vue'
    ),
  ProductLightsFrontTypeIcon: () =>
    import(
      /* webpackChunkName: "ProductLightsFrontTypeIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Product/ProductLightsFrontTypeIcon.vue'
    ),
  ProductLightsRearTypeIcon: () =>
    import(
      /* webpackChunkName: "ProductLightsRearTypeIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Product/ProductLightsRearTypeIcon.vue'
    ),
  ProductFenderDescriptionIcon: () =>
    import(
      /* webpackChunkName: "ProductFenderDescriptionIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Product/ProductFenderDescriptionIcon.vue'
    ),
  ProductChaincaseDescriptionIcon: () =>
    import(
      /* webpackChunkName: "ProductChaincaseDescriptionIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Product/ProductChaincaseDescriptionIcon.vue'
    ),
  ProductRearDerailleurIcon: () =>
    import(
      /* webpackChunkName: "ProductRearDerailleurIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Product/ProductRearDerailleurIcon.vue'
    ),
  ProductBottomBracketIcon: () =>
    import(
      /* webpackChunkName: "ProductBottomBracketIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Product/ProductBottomBracketIcon.vue'
    ),
  ProductWheelSpokeDescriptionIcon: () =>
    import(
      /* webpackChunkName: "ProductWheelSpokeDescriptionIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Product/ProductWheelSpokeDescriptionIcon.vue'
    ),
  ProductSteerBellDescriptionIcon: () =>
    import(
      /* webpackChunkName: "ProductSteerBellDescriptionIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Product/ProductSteerBellDescriptionIcon.vue'
    ),
  ProductChainDescriptionIcon: () =>
    import(
      /* webpackChunkName: "ProductChainDescriptionIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Product/ProductChainDescriptionIcon.vue'
    ),
  ProductFrontDerailleurIcon: () =>
    import(
      /* webpackChunkName: "ProductFrontDerailleurIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Product/ProductFrontDerailleurIcon.vue'
    ),
  ProductBrakeLeverDescriptionIcon: () =>
    import(
      /* webpackChunkName: "ProductBrakeLeverDescriptionIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Product/ProductBrakeLeverDescriptionIcon.vue'
    ),
  ProductShockIcon: () =>
    import(
      /* webpackChunkName: "ProductShockIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Product/ProductShockIcon.vue'
    ),
  ProductMaxTotalWeightKgNewIcon: () =>
    import(
      /* webpackChunkName: "ProductMaxTotalWeightKgNewIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Product/ProductMaxTotalWeightKgNewIcon.vue'
    ),
  ProductMainCategoryIcon: () =>
    import(
      /* webpackChunkName: "ProductMainCategoryIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Product/ProductMainCategoryIcon.vue'
    ),
  ProductGearTypeIcon: () =>
    import(
      /* webpackChunkName: "ProductGearTypeIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Product/ProductGearTypeIcon.vue'
    ),
  ProductGearSystemDescriptionIcon: () =>
    import(
      /* webpackChunkName: "ProductGearSystemDescriptionIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Product/ProductGearSystemDescriptionIcon.vue'
    ),
  ProductBidexCommodityGroupIcon: () =>
    import(
      /* webpackChunkName: "ProductBidexCommodityGroupIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Product/ProductBidexCommodityGroupIcon.vue'
    ),
  ItemTireDescriptionIcon: () =>
    import(
      /* webpackChunkName: "ItemTireDescriptionIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Product/ItemTireDescriptionIcon.vue'
    ),
  ItemTireRearDescriptionIcon: () =>
    import(
      /* webpackChunkName: "ItemTireRearDescriptionIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Product/ItemTireRearDescriptionIcon.vue'
    ),
  ProductDiscBrakeRotorRearIcon: () =>
    import(
      /* webpackChunkName: "ProductDiscBrakeRotorRearIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Product/ProductDiscBrakeRotorRearIcon.vue'
    ),
  ProductHeadsetIcon: () =>
    import(
      /* webpackChunkName: "ProductHeadsetIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Product/ProductHeadsetIcon.vue'
    ),
  ProductShifterIcon: () =>
    import(
      /* webpackChunkName: "ProductShifterIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Product/ProductShifterIcon.vue'
    ),
  ProductFrameStorageIcon: () =>
    import(
      /* webpackChunkName: "ProductFrameStorageIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Product/ProductFrameStorageIcon.vue'
    ),
}
